<template>
	<ly-basemodel title="停用" :class="isShow? '' : 'hide'" v-ref:model>
		<form class="form-horizontal">
			<label>*停用原因</label>
			<div style="text-align: center;margin-top:5px;">
				<textarea style="width:80%;height:150px;resize:none;background-color: #393e46;border-radius: 4px;padding:4px; " v-model="formdata.text"></textarea>
			</div>
		</form>
		<button type="button" class="btn btn-primary" slot="button" @click="submit" >确定</button>
	</ly-basemodel>
</template>
<script>
	var Http = require('../../utils/HttpHelper.js');
	var Com = require('../../utils/Common.js');
	/*
	*  启用弹出框详情
	*/
	module.exports = {
		data:function(){
			return {
				formdata:{
					text:'',//停用原因
				},
				show: function(){
                    this.$refs.model.show();
                },
                close: function() {
                    this.$refs.model.close();
                }
			}
		},
		props:['ids'],
		ready:function(){
		},
		methods:{
			/*
			* 确定停用原因
			*/
			submit:function(){
				var self = this;
				//this.$emit('newDisable');
				var data_ = {
					company_id:this.ids,//管理公司id
					type:0,//1是开启 0是停用
					stop_reason:this.formdata.text//停用原因
				}
				Http['statusChange'].create({
					key:[],
					data:data_,
					succ:function(rs){
						self.formdata.text = '';//清空文本域
						self.close();
						Com.tipDialog('停用操作成功！',1000,'success');
						self.$dispatch('newDisable',rs.now_status)//返回给父组件
					},
					err:function(msg){
						self.formdata.text = '';//清空文本域
						self.close();
						Com.tipDialog('请输入停用原因！',1000,'error');
					}
				})
				
			}
		},
		components:{
			'ly-basemodel':require('../popups/BaseModel.vue'),
		}

	}
</script>


/** WEBPACK FOOTER **
 ** disable.vue?005e3892
 **/